<template>
	<div class="table">
		<!-- 采购入库单 -->
		<div class="title">
			<span>采购入库单</span>
		</div>
		
		<div class="main">
			<!-- descriptions vertical / horizontal -->
			<div class="descriptions">
				<el-descriptions class="margin-top" direction="horizontal" :column="4" :size="size" border>
				    <el-descriptions-item>
				      <template slot="label">
				        <i class="el-icon-user"></i>
				        <span>入库人</span>
				      </template>
				      <!-- <span>{{ username }}</span> -->
					  <el-autocomplete
					    size="mini"
					    class="inline-input"
					    v-model="checker"
					    :fetch-suggestions="querySearch"
					    :placeholder="username"
					    @select="handleSelect"
					  ></el-autocomplete>
				    </el-descriptions-item>
					
					<el-descriptions-item>
					  <template slot="label">
					    <i class="el-icon-mobile-phone"></i>
					    入库人电话
					  </template>
					  <span>{{ userNumber }}</span>
					</el-descriptions-item>
					
				    <el-descriptions-item>
				      <template slot="label">
				        <i class="el-icon-s-shop"></i>
				        入库门店
				      </template>
				      <!-- <span>{{ Store }}</span> -->
					  <el-select v-model="Store" filterable :placeholder="Store" @change="changeSelect" size="mini" >
					      <el-option-group
					        v-for="group in optionsText"
					        :key="group.label"
					        :label="group.label">
					        <el-option
					          v-for="item in options3"
					          :key="item.value"
					          :label="item.label"
					          :value="item.value">
					        </el-option>
					      </el-option-group>
					  </el-select>
				    </el-descriptions-item>
					
					<el-descriptions-item>
					  <template slot="label">
					    <i class="el-icon-s-claim"></i>
					    入库库房
					  </template>
					  <!-- {{ Store }} -->
					  <el-select v-model="Store" filterable :placeholder="Store" @change="changeSelect" size="mini">
					      <el-option
					        v-for="item in options3"
					        :key="item.value"
					        :label="item.label"
					        :value="item.value">
					      </el-option>
					  </el-select>
					</el-descriptions-item>

					<el-descriptions-item>
					  <template slot="label">
					    <i class="el-icon-truck"></i>
					    供应商
					  </template>
					  <!-- {{ supplier SupplierEntityList }} -->
					  <el-select v-model="OptionsValue3" filterable placeholder="全部供应商" 
					  @focus="gys"
					  @change="handgysSelected"
					  :disabled="gysdisabled"
					  size="mini">
					      <el-option
					        v-for="item in options3"
					        :key="item.id"
					        :label="item.supplierName"
					        :value="item.supplierName">
					      </el-option>
					  </el-select>
					</el-descriptions-item>
					
					<el-descriptions-item>
					  <template slot="label">
					    <i class="el-icon-s-custom"></i>
					    验收人
					  </template>
					    <!-- <span>{{ checker }}</span> -->
						<el-autocomplete
						  size="mini"
						  class="inline-input"
						  v-model="checker"
						  :fetch-suggestions="querySearch"
						  placeholder="请输入或选择验收人"
						  @select="handleSelect"
						></el-autocomplete>
					</el-descriptions-item>
					
					<el-descriptions-item>
					  <template slot="label">
					    <i class="el-icon-edit-outline"></i>
					    备注
					  </template>
					  <el-input
					    type="textarea"
					    :rows="1"
					    placeholder="备注"
					    v-model="remark">
					  </el-input>
					</el-descriptions-item>
					
				  </el-descriptions>
			</div>
			<div class="stable">
				<!-- 输入框反馈 -->
				<div class="inputBox">
					<div class="tableHeader">
					  <!-- options -->
					  <el-select 
						  @change="handleSelected"
						  v-model="SelectValue" 
						  v-loading="loadings"
						  placeholder="扫条形码 / 追溯码 / 输入名称或首字母" 
						  size="mini"
						  filterable
						  remote
						  reserve-keyword
						  :remote-method="remoteMethod"
						  :no-data-text="NoDataText"
					  >
						<i slot="prefix" style="padding: 8px;" class="el-icon-plus" />
						<el-option
						  v-for="item in options"
						  :key="item.id"
						  :label="item.goodsName"
						  :value="item.id"
						  >
						   <span style="float: left">{{ item.genericName }}</span>
						   <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id }}</span>
						</el-option>
					  </el-select>
					</div>
					<div class="href" v-if="isShowNewAdd">
						<el-tooltip placement="bottom" effect="light" style="margin-top: 8px;font-size: 12px;">
							<div slot="content" style="cursor: pointer;color: darkred;" @click="goToRout()">去新增</div>
						  <el-link>没有想要的结果<i class="el-icon-question"></i></el-link>
						</el-tooltip>
					</div>
				</div>
				<!-- 表格 -->
				<el-table
					v-if="isShow"
				    :data="selectedData"
					v-loading="loading"
					@select="handleSelectionChange"
					row-key="id" 
					border 
					@row-dblclick="dbclick" 
					:cell-class-name="tableCellClassName" 
					:row-style="{height:'40px'}"
					>
					<el-table-column
					type="selection"
					width="40">
					</el-table-column>
				    <el-table-column prop="barCode" label="药品编码" width="120" align='center'></el-table-column>
					<el-table-column label="随货单号" width="140" align='center'>
						<template slot-scope="scope" :loading="loading">
						  <span>{{ scope.row.serialNumber }}</span>
						</template>
					</el-table-column>
					<el-table-column label="药品名称" width="120" align='center'>
						<template slot-scope="scope">
						  <span>{{ scope.row.goodsName }}</span>
						</template>
					</el-table-column>
					<el-table-column label="状态" width="60" align='center'>
						<template slot-scope="scope">
						  <span>{{ status == 2 ? '未结算' : '已结算' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="售价" width="60" align='center'>
						<template slot-scope="scope">
						  <span>{{ '￥' + scope.row.retailPricing }}</span>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="60" align='center'>
						<template slot-scope="scope">
						  <span>{{ scope.row.minPackUnit }}</span>
						</template>
					</el-table-column>
					<el-table-column label="数量" width="120" align='center'>
						<template slot-scope="scope">
						 <el-input-number size="mini" :disabled="disabled" controls-position="right" v-model="num" @change="handleChange" :min="1" :max="999" label="描述文字"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column prop="buyingPric" label="进价" width="60" align='center'>
						<template slot-scope="scope">
						  <span>{{ '￥' + buyingPrice }}</span>
						</template>
					</el-table-column>
					<el-table-column label="金额" width="60" align='center'>
						<template slot-scope="scope">
						  <span>{{ '￥' + totalPrice }}</span>
						</template>
					</el-table-column>
					<!-- 字段映射 -->
					<el-table-column prop="dateManufacture" label="生产日期" width="160" align='center'>
						<template slot-scope="scope">
							<el-date-picker
							  size="mini"
							  v-model="scope.row.dateManufacture"
							  :ref="scope.row.index + ',' + scope.column.index"
							  v-if="scope.row.index + ',' + scope.column.index == currentCell"
							  @blur="hideInput"
							  align="center"
							  type="date"
					 		  placeholder="选择日期"
							  :picker-options="pickerOptions">
							</el-date-picker>
							<span v-else>{{ scope.row.dateManufacture }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="effectiveDate" label="有效日期" width="160" align='center'>
						<template slot-scope="scope">
							<el-date-picker
							  size="mini"
							  v-model="scope.row.effectiveDate"
							  :ref="scope.row.index + ',' + scope.column.index"
							  v-if="scope.row.index + ',' + scope.column.index == currentCell"
							  @blur="hideInput"
							  align="center"
							  type="datetime"
							  placeholder="选择日期"
							  :picker-options="pickerOptions">
							</el-date-picker>
							<span v-else>{{ scope.row.effectiveDate }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="batchNumber" label="生产批号" width="100" align='center'>
					  <template slot-scope="scope">
						<el-input size="mini"
						  v-model="scope.row.batchNumber"
						  :ref="scope.row.index + ',' + scope.column.index"  
						  v-if="scope.row.index + ',' + scope.column.index == currentCell"
						  @blur="hideInput"
						  placeholder="请输入"/>
						<span v-else>{{ scope.row.batchNumber }}</span>
					  </template>
					</el-table-column>
					
				    <el-table-column
					 align='center'
				     fixed="right"
				     label="操作"
				     width="60">
				     <template slot-scope="scope">
				       <!-- <el-button @click="handleEditClick(scope.row)" type="text" size="small">编辑</el-button> -->
				       <el-button
				         @click.native.prevent="deleteRow(scope.$index, scope.row)"
				         :disabled="disabled"
				   	     type="text"
				         size="small"
						 >
				         移除
				       </el-button>
				     </template>
				    </el-table-column>
				  </el-table>
			</div>
			<!-- tj btn -->
			<div class="addList">
				<div class="btna" style="flex: 3;" >
					<el-button type="primary" size='mini' v-show="this.selectedData.length!=0" @click="addNewList">继续添加<i class="el-icon-upload el-icon--right"></i></el-button>
				</div>
				<div class="text">
					<span>品种：{{ kindsOf + '，' }}</span>
					<span>数量：{{ nums + '，' }}</span>
					<span>总金额：{{ '￥' + totalPrice + '，' }}</span>
					<span>含税金额：{{ '￥' + tax }}</span>
				</div>
			</div>
			<div class="addTo">
				<el-button v-for="(v,i) in addTo" :key="i" :type="v.type" size="mini" :disabled="disabled"
					@click="MakeSure(i)">{{ v.title }}</el-button>
			</div>
		</div>


	</div>
</template>

<script>
	// 接口相关
	import { 
		addDrugs,addPurchase,
		selecting,selectingDrugCode,SupplierEntityList,selectDropDownList,
	} from "@/api/PSI";
	// selfs / js

	  export default {

		data() {
		  return {
			    w: document.body.clientWidth - 160, //宽度
				// boolean
				isShow:false,//控制表格的展示
			    disabled:true,
				gysdisabled:true,//供应商选择禁用
				dialogVisible: false,
				loading: false,
				loadings:false,
				isShowNewAdd:false,//无结果新增
				booleanArr:false,//点击择值
				fullscreenLoading: false,//整页加载
				// string
				status:'2',// '结算状态：1：已结算 2：未结算 3：待审核',
				validityPeriodApprovalNumber:'',
				productDate:'ww',
				currentCell: null,
				timerId: '',
				serialNumber:'',
				batchNumber:'',//生产批号
				dateManufacture:'',//生产日期
				effectiveDat:'',//有效日期
				NoDataText:'loading', //elSelectedResultTitle
				SelectValue:'',
				OptionsValue2:'',
				OptionsValue3:'九阵通医药',
				kindsOf:'',
				nums:'',
				scanCode:'', //条形码/追溯码输入内容
				username:'', // 当前用户 | 入库人
				Store:'', //入库kuf
				StoreHouse:'', 
				supplier:'', 
				goodsNum:'', 
				checker:'', 
				remark:'', 
				userNumber:'', 
				goodsName:'', 
				retailPricing:'', 
				minPackUnit:'', 
				size: 'mini',
				direction: 'rtl',
				// number
				selected:'',//选中的单行数据售价/金额
				num:'',
				costPrice:'',
				totalPrice:'',//总金
				buyingPrice:'2',//进货价
				tax:'',//税金
				// arr
				uss:[{value: '九州通医药',label: '九州通医药'}, { value: '杀杀',label: '杀杀'}],
				sendToFather:[],//传递给父组件的数组参数
				multipleSelection:[],
				userinfo:[],
				tableData: [],
				selectedData:[],
				optionsText: [{value: '结果',label: '结果'}, { value: '无结果集',label: '无结果集'}],
				options3: [{value: '九州通医药',label: '九州通医药'}, { value: '杀杀',label: '杀杀'}],
				desArr:[
					{ label:'label',descriptName:'入库人',icon:'el-icon-user',fullName:'张培东' },
					{ label:'label',descriptName:'入库门店',icon:'el-icon-user',fullName:'九阵软件' },
					{ label:'label',descriptName:'入库库房',icon:'el-icon-user',fullName:'邦泰国际分部' },
					{ label:'label',descriptName:'供应商',icon:'el-icon-user',fullName:'阿里巴巴' },
					{ label:'label',descriptName:'入库人电话',icon:'',fullName:'18199886655' },
					{ label:'label',descriptName:'随货单号',icon:'',fullName:'Jz666888' },
					{ label:'label',descriptName:'验收人',icon:'',fullName:'古永' },
					{ label:'label',descriptName:'备注',icon:'',fullName:'黄丹' },
				],
				desArrNew:[],
				options: [],
				addTo:[
					// { back:"back", title:"返回", type:"primary" },
					{ MakeSure:"MakeSure", title:"确定入库", type:"primary", icon:"el-icon-plus" },
					{ save:"save", title:"保存草稿", type:"", icon:"el-icon-time" },
					{ close:"close", title:"关闭", type:"", icon:"el-icon-upload2" },
				],
				pickerOptions: {
					  shortcuts: [{
						text: '今天',
						onClick(picker) {
						  picker.$emit('pick', new Date());
						}
					  }, {
						text: '昨天',
						onClick(picker) {
						  const date = new Date();
						  date.setTime(date.getTime() - 3600 * 1000 * 24);
						  picker.$emit('pick', date);
						}
					  }, {
						text: '一周前',
						onClick(picker) {
						  const date = new Date();
						  date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
						  picker.$emit('pick', date);
						}
					  }]
					},

				states: ["Alabama", "Alaska", "Arizona",
				        "Arkansas", "California", "Colorado",
				        "Connecticut", "Delaware", "Florida",
				        "Georgia", "Hawaii", "Idaho", "Illinois",
				        "Indiana", "Iowa", "Kansas", "Kentucky",
				        "Louisiana", "Maine", "Maryland",
				        "Massachusetts", "Michigan", "Minnesota",
				        "Mississippi", "Missouri", "Montana",
				        "Nebraska", "Nevada", "New Hampshire",
				        "New Jersey", "New Mexico", "New York",
				        "North Carolina", "North Dakota", "Ohio",
				        "Oklahoma", "Oregon", "Pennsylvania",
				        "Rhode Island", "South Carolina",
				        "South Dakota", "Tennessee", "Texas",
				        "Utah", "Vermont", "Virginia",
				        "Washington", "West Virginia", "Wisconsin",
				        "Wyoming"],
				 list: [],
		  }
		},
		created() {
			window.addEventListener("resize", this.resizeHandle);
			// this.checker = this.username
		},
		mounted() {
			console.log(this.status);
			this.restaurants = this.loadAll();
			this.list = this.states.map(item => {
				return { value: `value:${item}`, label: `label:${item}` };
			  });
			// getlocal
			this.userinfo = JSON.parse(localStorage.getItem('userInfo'))
			// this.desArr = Object.values(this.userinfo); = Object.values(this.userinfo)
			// console.log(this.userinfo);
			// 赋值
			this.username = this.userinfo.userName
			this.Store = this.userinfo.clinicName
			this.userNumber = this.userinfo.phoneNumber

			this.desArrNew = this.desArr.map(item => {
				return item.fullName
			})
			// console.log(this.desArrNew);
			//调用获取数据列表函数
			this.loadData();
		},
		methods: {
			// 给单元格绑定横向和竖向的index，这样就能确定是哪一个单元格
			    tableCellClassName({row, column, rowIndex, columnIndex}){
			        row.index = rowIndex;
			        column.index = columnIndex;
					// console.log(row.index + ',' + column.index);
			    },
			    // 获得当前双击的单元格的横竖index，然后拼接成一个唯一字符串用于判断，并赋给currentCell  // 拼接后类似这样："1,0","1,1",
			    dbclick(row,column) {
			        this.currentCell = row.index + ',' + column.index;
					console.log(column.index);
			        // 这里必须要setTimeout，因为在点击的时候，input才刚被v-if显示出来，不然拿不到dom
			        setTimeout(() => {
						if(column.index == 9 || column.index == 10 || column.index == 11 ){
							console.log('支持');
							// 双击后自动获得焦点
							this.$refs[row.index + ',' + column.index].focus();

						}else{
							console.log('不支持');
						}
			            
			        })
			    },
			    // 当input失去焦点的时候，隐藏input
			    hideInput(){
			        this.currentCell = null;
			    },
			    // 删除
			    onDelete(row) {
			      const index = this.selectedData.indexOf(row);
			      if (index !== -1) {
			        this.selectedData.splice(index, 1);
			      }
			    },
			// 选择模糊搜索框中的值
			handleSelected(val){
				// vue.runtime.esm.js:3065 TypeError: value.push is not a function
				// this.booleanArr = true;//对象赋值开关
				// 匹配检索id
				let user = _.find(this.options, v => v.id == val );
				this.isShow = true;//控制表格的展示
				this.selectedData.push(user);
				// 条件
				if(this.selectedData != []){
					// 取消禁用
					this.gysdisabled = false;
				}
				console.log(this.selectedData);
			},
			//获取列表
			async loadData() {
				// let rs = await patientsList({
				// // currentPage: this.currentPage,
				// // pageSize: this.pageSize,
				// });
				// let { total, data } = rs;
				// console.log(rs);
				// this.total = total;
				// this.tableData = rs.data;
			},
			//  模糊搜索接口函数
			async getData(){
				let res = await selectingDrugCode({
					drugName: this.SelectValue,
					drugCode: ''
				})
				// console.log(res);
				if(res.data.content.length === 0){
						this.$message({
						  type: 'info',
						  message: `数据库暂无相关数据`
						});
						this.NoDataText = '暂无相关数据'
						this.loadings = false;//关闭加载
						this.options = [];//null
						this.isShowNewAdd = true//打开新增提示
				}else{
					// 赋值给Options
					this.options = res.data.content
					// sessionStorage.setItem('MedicItems', JSON.stringify(this.tableData));
					this.$notify({
						  title: '匹配成功',
						  message: '已添加到入库单列表，如需继续添加请点击‘继续添加’按钮',
						  type: 'success'
						});
					this.loadings = false;
				}
			},

			// 输入或扫码框触发事件
			 remoteMethod(query) {
				this.SelectValue = query
				this.loadings = true
				// 清除之前的定时器
				    if (this.timerId) {
						clearTimeout(this.timerId);
				    }
				  // 设置新的定时器
					this.timerId = setTimeout(() => {
					  // 每隔一段时间执行逻辑
						// console.log(this.SelectValue);
						this.loadings = true
						if(/\s/g.test(this.SelectValue) == true ){
							this.$alert('值不能为空白格，请重试！','提示', {
								confirmButtonText: '确定',
								type: 'warning',
							});
							this.loadings = false;
						}else{
							// console.log('没空格走接口');
							// this.loadings = true
							this.getData()
						}
					  // 清除定时器
					  this.timerId = null;
					}, 1500); // 间隔时间
			},
			goToRout(){
				// 或使用路径
				// const { href } = this.$router.resolve('/PSI/storeManger');
				// console.log(href); // 输出 "/PSI/storeManger" 的URL字符串
				this.$router.push('/PSI/storeManger')
			},
			// edit
			async MakeSure(i){
				// i event
				switch(i){
					case 0:
					// 处理索引0的逻辑
					let purchaseInventoryList = 
						[
							{
						"batchNumber": "",
						"buyingPrice": this.buyingPrice,
						"completionTime": "",
						"dateManufacture": "",
						"drugCode": "",
						"drugName": this.goodsName,
						"drugsWarehousingId": this.id,
						"effectiveDate": "",
						"id": 0,
						"makePeople": "",
						"noTaxInclusiveAmount": this.totalPrice,
						"oddNumbers": this.goodsNum,
						"quantity": this.nums,
						"salesPrice": this.selected,
						"settlementStatus": this.status,
						"status": this.status,
						"storagePersonnel": this.username,
						"storeroom": this.Store,
						"supplier": this.OptionsValue3,
						"taxInclusiveAmount": this.totalPrice,
						"traceabilityCode": "",
						"types": "1",
						"unit": "",
						"varietiesNumber": this.kindsOf,
						"serialNumber":this.serialNumber,
						"dateManufacture": this.dateManufacture,
						"effectiveDate": this.effectiveDate,
						"batchNumber": this.batchNumber,
							}
						]
					
					// 调接口
					let rs = await addPurchase(purchaseInventoryList)
					console.log( rs);
					if(rs.code === 200){
						// 定时器
						// this.fullscreenLoading = true;
						setTimeout(() => {
							this.$notify({
								  title: '入库成功',
								  message: '已添加到入库单列表',
								  type: 'success'
								});
								this.fullscreenLoading = false;
							}, 2000)
						sessionStorage.setItem('ToFather', JSON.stringify(this.sendToFather));
						this.$router.push('/PSI/shopStore')
					}else{
						
					}
					
					
					break;
					case 1:
					// 处理索引1的逻辑
					console.log('1')
					break;
					case 2:
					// 处理索引2的逻辑
					// 返回上一级
					this.$router.go(-1) // 返回
					break;
				}
			},
			// 供应商
			async gys(){
				let result = await selectDropDownList({})
				// console.log(result,'供应商下拉列表');
				this.options3 = result.data.content
			},
			// 供应商选择
			handgysSelected(){
				// console.log(this.OptionsValue3);
			},
			changeSelect(e){
				console.log(e);
			},
			handleSelectionChange(val) {
				this.ValNum = val.length
				//调用步进器
				this.handleChange(val);
				console.log(val);
				// 定义一个索引字段
				let chooseIndex = val.length-1;
				if(val.length){
					this.loading = true;
					setTimeout(() => {
				// 将其下的ID类型改变用于判断该选中行是否进行取消禁用
					val[chooseIndex].id = val[chooseIndex].id.toString();
				// 取消禁用
					this.disabled = false
					this.selected = val[chooseIndex].retailPricing
					this.id = val[chooseIndex].id
					this.goodsName = val[chooseIndex].goodsName
					// this.retailPricing = val[chooseIndex].retailPricing
					this.retailPricing == '' ? 0 :val[chooseIndex].retailPricing
					this.minPackUnit = val[chooseIndex].minPackUnit
					this.dateManufacture = val[chooseIndex].dateManufacture
					this.effectiveDate = val[chooseIndex].effectiveDate
					this.batchNumber = val[chooseIndex].batchNumber
				// 赋值
					this.kindsOf = val.length
					/*
						随货单号：RK + 年 + 月 + 日 + 时分秒
					*/
				    if(val[chooseIndex].serialNumber == null){
						let rkName = 'RK';
						const now = new Date(); //创建时间日期对象
						const year = now.getFullYear(); //年
						const month = now.getMonth() + 1; //月份是从0开始的
						const day = now.getDate(); //日
						const hours = now.getHours(); //时
						const minutes = now.getMinutes(); //分
						const seconds = now.getSeconds(); //秒
						const currentDate = `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`.replace(/-/g, '') //替换操作
						// 开始自动生成随货单号
						this.serialNumber = rkName + currentDate
						// console.log(this.serialNumber);
						val[chooseIndex].serialNumber = this.serialNumber;
						this.loading = false;
					}
				}, 1500); 
				
				}else{
					// 禁用
					this.disabled = true
				}
				
			  },
			deleteRow(index, rows) {
			  console.log(index,rows[index]);
			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			  },
			  createFilter(queryString) {
				return (restaurant) => {
				  return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			loadAll() {
				return [
				  { "value": "古永三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },
				  { "value": "黄丹首尔炸鸡Hot honey（仙霞路）", "address": "上海市长宁区淞虹路661号" },
				  { "value": "杨勇旺角茶餐厅", "address": "上海市普陀区真北路988号创邑金沙谷6号楼113" },
				  { "value": "陈科均贡茶(北新泾店）", "address": "上海市长宁区仙霞西路" },
				  { "value": "王耀萱鲜榨果汁 NONO JUICE", "address": "上海市长宁区天山西路119号" },
				  { "value": "杜作强蛋糕胖仙女纸杯（上海凌空店）", "address": "上海市长宁区金钟路968号1幢18号楼一层商铺18-101" },
				  { "value": "张培东鸡排超级奶爸", "address": "上海市嘉定区曹安公路曹安路1685号" },
				  { "value": "陈南手抓饼茶芝兰", "address": "上海市普陀区同普路1435号" },
				  { "value": "杨世江浓缩咖啡星移", "address": "上海市嘉定区新郁路817号" },
				  { "value": "吴笙榕阿姨奶茶/豪大大", "address": "嘉定区曹安路1611号" },
				  { "value": "古沿宏十二泷町", "address": "上海市北翟路1444弄81号B幢-107" },
				  { "value": "张成伟浮生若茶（凌空soho店）", "address": "上海长宁区金钟路968号9号楼地下一层" },
				  { "value": "新麦甜四季甜品炸鸡", "address": "嘉定区曹安公路2383弄55号" },
				  { "value": "Monica摩托主题咖啡店", "address": "嘉定区江桥镇曹安公路2409号1F，2383弄62号1F" },
				];
			  },
			  handleSelect(item) {
				console.log(item);
			},
			addNewList(){
				this.scanCode = '' 
			},
			// 步进器
			handleChange(val){
				// val+=1;
				if(val){
					this.nums = this.num * this.ValNum
					this.totalPrice = this.selected * this.nums
					// this.retailPricing = this.selected
					// this.totalPrice = this.selected * this.nums
					// console.log(this.num+'nums<<<<<<<<<',this.ValNum+'arrLength');
				}else{
					val = 1;
				}	
			},
			// 编辑
			handleEditClick(scope){
				this.disabled = false
				console.log(scope.costPrice);
			},
		   //窗口触发函数
		   resizeHandle() {
		   	console.log("窗口发生改变");
		   	this.w = document.clientWidth - 160;
		   },
		}
		
	  }
</script>

<style lang="less" scoped>
// el
  .my-content {
	background: #FDE2E2;
  }
.table{
	
	// tit
	.title{
		padding-bottom: 12px;
		border-bottom: 2px solid #dfdfdf;
		span{
			font-size: 14px;
			font-weight: bold;
			font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
		}
	}
	// cont
	.main{
		margin-top: 12px;
		// descriptions
		.descriptions{
			.margin-top{
				border-radius: 20px;
			}
		}
		// .table
		.stable{
			/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
				width: 120px;
			}

			/deep/ .el-table{
				font-size: 12px!important;
			}
			/deep/ .el-input--mini .el-input__inner{
				cursor: pointer;
			}
			/deep/.el-select__tags{
				padding-left: 18px;
			}
			.inputBox{
				display: flex;
				flex-direction: row;
			}
			padding: 12px;
			background-color: #fff;
			margin-top: 12px;
			.tableHeader{
				width: 17%;
				height: 40px;
			}
			
			// deep
			/deep/.el-input-number--mini{
				width: 90px;
			}
		}
		//add
		.addList{
			/deep/.el-autocomplete-suggestion li{
				font-size: 12px;
			}
			display: flex;
			justify-content: left;
			width: 100%;
			padding: 0 12px 12px 12px;
			background-color: #fff;
			.text{
				flex: 1;
				span{
					font-size: 12px;
					color: #828282;
				}
			}
		}
		.addTo{
			display: flex;
			justify-content: right;
			padding: 8px;
			margin-top: 8px;
			background-color: #fff;
		}
	}
	
}

</style>
